const ROLES = {
  ADMIN: 'C3',
  DIRECTOR_GENERAL: 'Director general',
  DIRECTOR_AREA: 'Director de área',
  SUPERVISOR: 'Supervisor',
  PROGRAMACION: 'Programación_CONFIABILIDAD',
  PSICOLOGIA: 'Psicología_CONFIABILIDAD',
  ISE: 'ISE_CONFIABILIDAD',
  ANTECEDENTES: 'Antecedentes_CONFIABILIDAD',
  VALIDACION: 'Validacion_CONFIABILIDAD',
  MEDICO: 'Medico_CONFIABILIDAD',
  POLIGRAFO: 'Poligrafo_CONFIABILIDAD',
  INTEGRACION: 'Integracion_CONFIABILIDAD',
};

export default ROLES;
